import React, { createContext, useContext, useState, useEffect } from "react";

const AudioContext = createContext();

export const useAudio = () => useContext(AudioContext);

export const AudioProvider = ({ children }) => {
  const [muted, setMuted] = useState(() => {
    const storedMuted = localStorage.getItem("audioMuted");
    return storedMuted ? JSON.parse(storedMuted) : false;
  });

  useEffect(() => {
    localStorage.setItem("audioMuted", JSON.stringify(muted));
  }, [muted]);

  const value = { muted, setMuted };

  return (
    <AudioContext.Provider value={value}>{children}</AudioContext.Provider>
  );
};
